import { Component, OnInit } from "@angular/core";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { SkillsService } from "../../../auth/service/skills.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CertificationService } from "../../../auth/service/certification.service";
import { UtilsService } from "../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../auth/service";
import { Router } from "@angular/router";
import { EducationTitleService } from "../../../auth/service/education-title.service";
import { EducationSubjectService } from "../../../auth/service/education-subject.service";
import { TutorialService } from "../../../auth/service/tutorial.service";

@Component({
  selector: "app-onboarding-certifications",
  templateUrl: "./onboarding-certifications.component.html",
  styleUrls: ["./onboarding-certifications.component.scss"],
})
export class OnboardingCertificationsComponent implements OnInit {
  //  Public
  public coreConfig: any;
  public currentUser: any;
  public items_certifications: any = [];
  public items_education: any = [];
  public new_certificate: string;
  public indexOfItemCertifications: number = 0;
  public showErrors: boolean = false;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {SkillsService} _skillService
   * @param _modalService
   * @param {CertificationService} _certificationService
   * @param _utilService
   * @param _userService
   * @param _educationTitleService
   * @param _authenticationService
   * @param _router
   * @param _educationSubjectService
   * @param _tutorialService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    public _skillService: SkillsService,
    public _modalService: NgbModal,
    public _certificationService: CertificationService,
    public _utilService: UtilsService,
    private _userService: UserService,
    public _educationTitleService: EducationTitleService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    public _educationSubjectService: EducationSubjectService,
    public _tutorialService: TutorialService,
  ) {
    this._utilService.disableAutoHideLoading();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  async ngOnInit() {
    await this._educationSubjectService.getList();
    await this._certificationService.getList();
    await this._educationTitleService.getList();

    const currentUser: any = this._authenticationService.getCurrentUser();
    if (currentUser && currentUser.send_onboarding === 1) {
      await this._router.navigateByUrl("/dashboard/main");
      this._utilService.hideLoading();
      return false;
    }
    this.currentUser = await this._userService.get(currentUser.hash);

    this.currentUser.certifications.map((cert: any) => {
      this.items_certifications.push({ cert_id: cert.cert_id });
    });

    this.currentUser.educations.map((item: any) => {
      this.items_education.push({
        title_id: item.title_id,
        subject: item.title_name === "Laurea" ? item.graduate_id : item.subject,
        vote: item.vote,
        current: item.current,
        primary: item.primary,
        name: item.title_name,
      });
    });

    this.addItem();
    this.addEducationItem();
    this._utilService.hideLoading();
  }

  /**
   * Add Item
   */
  addItem() {
    this.items_certifications.push({
      cert_id: "",
    });
  }

  /**
   * DeleteItem
   *
   * @param index
   */
  deleteItem(index: number) {
    delete this.items_certifications[index];
    this.items_certifications = this.items_certifications.filter((i) => i);
  }

  public modalOpen(modalBasic, index: number) {
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.indexOfItemCertifications = index;
  }

  async addModalObject() {
    if (this.new_certificate == undefined) {
      await this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_INSERT" });
      return false;
    }
    this.items_certifications.push({
      cert_id: this.new_certificate,
      isNew: 1,
    });
    this.new_certificate = "";
    if (this.items_certifications[this.indexOfItemCertifications].cert_id.length < 1) {
      this.items_certifications.splice(this.indexOfItemCertifications, 1);
    }
  }

  addEducationItem() {
    this.items_education.push({ name: null, title_id: 0, subject: null, vote: null, current: false, primary: false });
  }

  removeEducationItem(index: number) {
    delete this.items_education[index];
    this.items_education = this.items_education.filter((i) => i);
  }

  onSetPrimaryEducation(education: any, i: number) {
    if (education.primary) {
      this.items_education.map((value: any, index: number) => {
        if (index !== i) {
          this.items_education[index].primary = false;
        }
      });
    }
  }
  cancelVote(i: number) {
    if (this.items_education[i].current) {
      this.items_education[i].vote = null;
    }
  }

  async save() {
    this.showErrors = true;
    this.items_education.map((item) => {
      if (!!item.subject && typeof item.subject === "string") {
        item.subject = item.subject.trim();
      }
      if (!!item.vote) {
        item.vote = item.vote.trim();
      }
    });
    let educations: any = this.items_education.filter((i) => !!i.title_id && !!i.subject);

    //Controllo per formazione
    if (!educations || educations.length < 1) {
      return this._utilService.showSWALError({ text: "COMPLETE_EDUCATION_SECTION" });
    }
    const checkEducationPrimary = educations.filter((skill: any) => skill.primary);
    if (checkEducationPrimary.length < 1) {
      return this._utilService.showSWALError({ text: "SELECT_PRIMARY_EDUCATION" });
    }
    //check duplicate certifications
    const checkedArray = this.items_certifications.reduce((unique, o) => {
      if (!unique.some((obj) => obj.cert_id === o.cert_id)) {
        unique.push(o);
      }

      return unique;
    }, []);
    if (this.items_certifications.length !== checkedArray.length) {
      await this._utilService.showSWALError({ text: "ERROR_DUPLICATE_CERTIFICATIONS" });
      return false;
    }
    //END check duplicate certifications

    const saveData = {
      certifications: this.items_certifications.filter((i) => i.cert_id.length > 0 || i.cert_id > 0),
      educations,
    };
    this._utilService.showLoading();
    return this._userService
      .update(this.currentUser.hash, saveData)
      .then(() => {
        this._utilService.hideLoading();
        this._router.navigateByUrl("/onboarding/experiences");
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_INSERT" });
      });
  }

  showVideo() {
    this._tutorialService.video_to_play = "Onboarding";
    this._tutorialService.force_open_modal = true;
  }
}
